/**
 * This is a modified version of a file from libqp v1.1.0
 *
 * Original:
 * https://github.com/nodemailer/libqp/blob/v1.1.0/lib/libqp.js
 * Copyright (c) 2014 Andris Reinman
 *
 * Modifications:
 * Copyright (c) 2017 Ross Johnson
 *
 * MIT licensed.
 */

/**
 * Decodes a Quoted-Printable encoded string to a Buffer object
 *
 * @param {String} str Quoted-Printable encoded string
 * @returns {Buffer} Decoded value
 */
export function qpDecode(str: string): Buffer {
	str = str
		// remove invalid whitespace from the end of lines
		.replace(/[\t ]+$/gm, '')
		// remove soft line breaks
		.replace(/=(?:\r?\n|$)/g, '');

	const encodedBytesCount = (str.match(/=[\da-fA-F]{2}/g) || []).length;
	const bufferLength = str.length - encodedBytesCount * 2;
	const buffer = Buffer.allocUnsafe(bufferLength);
	let bufferPos = 0;

	for (let i = 0, len = str.length; i < len; i++) {
		const chr = str.charAt(i);
		let hex;
		// eslint-disable-next-line no-cond-assign
		if (chr === '=' && (hex = str.slice(i + 1, i + 3)) && /[\da-fA-F]{2}/.test(hex)) {
			buffer[bufferPos++] = parseInt(hex, 16);
			i += 2;
			continue;
		}
		buffer[bufferPos++] = chr.charCodeAt(0);
	}

	return buffer;
}
